'use client'
import { Icon } from '@/components'
import { useWishlistStore } from '@/store'
import { IconButton, styled } from '@mui/material'
import Badge, { badgeClasses } from '@mui/material/Badge'

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -7px;
    right: -7px;
    transform: translate(50%, -100%);
    font-size: 0.75rem;
  }
`
export const WishlistHeader = () => {
  const { wishlistItems } = useWishlistStore()
  return (
    <IconButton
      sx={(theme) => ({
        background: theme.palette.primary.light,
        padding: '10px',
        '&:hover': { background: '#222' },
        position: 'relative',
        display: { xs: 'none', md: 'inline-flex' },
      })}
    >
      <Icon.Heart sx={{ fontSize: "1rem", color: "primary.main" }} />
      <CartBadge badgeContent={wishlistItems?.items?.length ?? 0} color="primary" overlap="circular" />
    </IconButton>
  )
}